import { FanfliqModal } from 'components/modal';
import { SELECTED_THEME, themeColors } from 'utils/theme';
import IcCheck from 'assets/ic_check.svg';
import IcAppstore from 'assets/ic_appstore.svg';
import IcPlaystore from 'assets/ic_playstore.svg';
import { useParams, useSearchParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import axios from 'axios';
import { Spinner } from 'react-bootstrap';
import { getAccessToken } from 'api/http-common';

export const DownloadPage = () => {
  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const [user, setuser] = useState();

  const fetchUserDetails = async () => {
    const headers = {
      Authorization: `Bearer ${getAccessToken()}`,
    };
    try {
      const response = await axios.get(
        `https://api.fanfliq.com/v1/users/${localStorage.getItem('id')}`,
        {
          headers,
        },
      );
      setuser(response.data);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    if (searchParams.get('email')) {
      setuser({
        email: searchParams.get('email'),
      });
    } else {
      fetchUserDetails();
    }
  }, []);

  return (
    <div>
      <FanfliqModal
        show={true}
        dialogClass="dialog-small"
        title={
          <div>
            <img src={IcCheck} alt="check" />
            <div
              className="text-20 bold"
              style={{
                color: themeColors[SELECTED_THEME].textPrimary,
                fontSize: '2rem',
              }}
            >
              Your Order was successful!!
            </div>
          </div>
        }
        subtitle={
          <div
            className="text-20"
            style={{
              color: themeColors[SELECTED_THEME].textPrimary,
              fontWeight: 400,
            }}
          >
            {user ? (
              <div>
                {`You’ll receive the official QR code ticket and the bill for your payment on your email ${user.email} shortly.`}
                <br />
                <br />
                Download the app now for exclusive access to music, merch,
                tickets, and more.
              </div>
            ) : (
              <Spinner />
            )}
          </div>
        }
        primaryBtn={
          <div style={{ display: 'flex' }} className="gap-16px hover-link-ff">
            <a
              href={`https://join.fanfliq.app/hDPC/obrcx6a0?deep_link_sub1=purchase&deep_link_value=${id}&af_force_deeplink=true`}
            >
              <img className="store-btn" src={IcPlaystore} alt="playstore" />
            </a>
            <a
              href={`https://join.fanfliq.app/hDPC/obrcx6a0?deep_link_sub1=purchase&deep_link_value=${id}&af_force_deeplink=true`}
            >
              <img className="store-btn" src={IcAppstore} alt="appstore" />
            </a>
          </div>
        }
      />
    </div>
  );
};
